import { render } from "./PageSearch.vue?vue&type=template&id=7c68d2d4"
import script from "./PageSearch.vue?vue&type=script&lang=js"
export * from "./PageSearch.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjektetRentaCar\\mdsgroup\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QPopupProxy});
